import { TouchableNativeFeedback } from 'react-native';
export default TouchableNativeFeedback;
//# sourceMappingURL=TouchableNativeFeedback.js.map